<ng-container *transloco="let t; read: 'assignment'" >
    <h2>{{t('services')}}</h2>
    <kendo-grid
  [data]="(assignment$ | async)?.assignmentServices"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"

>
  <ng-template kendoGridToolbarTemplate *permissionIf="'Permissions.AssignmentServices.Create'">
    <button kendoGridAddCommand>{{t('add')}}</button>
  </ng-template>

  <kendo-grid-column field="serviceId" [title]="t('linkedService')" width="200">
    <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem?.service?.name ?? "-"}}
    </ng-template>

    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
    <kendo-formfield>
      <kendo-dropdownlist
            [data]="services"
            textField="name"
            valueField="id"
            [valuePrimitive]="false"
            [formControl]="formGroup.get('serviceId')"
        >
        </kendo-dropdownlist>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="remarks" [title]="t('remarks')">
    <ng-template 
    let-isNew="isNew"
      kendoGridEditTemplate 
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      >
      <kendo-formfield>
        <kendo-textbox
          [formControl]="formGroup.get('remarks')"
        ></kendo-textbox>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column 
    field="isCompleted" 
    [title]="t('isCompleted')"
    width="75"
    >
    <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.isCompleted ? "Ja" : "Nein"}}
      </ng-template>
      <ng-template 
      let-isNew="isNew"
        kendoGridEditTemplate 
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        >
          <input 
            *ngIf="!isNew"
            type="checkbox" 
            kendoCheckBox
            [value]="dataItem.isCompleted"
            [formControl]="formGroup.get('isCompleted')"
          />
      </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="time" [title]="t('time')" width="100">
    <ng-template kendoGridCellTemplate let-dataItem>

        <input
          kendoTextBox
          [readonly]="true"
          [value]="dataItem.timeObj | timeSpanToString"
        />
        
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
        <input
          kendoTextBox
          [formControl]="formGroup.get('time')"
          placeholder="00:00"
        />
        <kendo-formerror 
          *ngIf="formGroup.get('time')?.hasError('invalidTimeFormat') && formGroup.get('time')?.touched"
        >{{t('errors.wrongTimeFormat')}}</kendo-formerror>
      </ng-template>

    <ng-template 
      kendoGridFooterTemplate 
      let-column
      let-dataItem
    >
      <span>
        {{ (assignment$ | async)?.defaultTimeTotal | timeSpanToString}}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column 
  field="totalTimeEntries" 
  [title]="t('totalTimeEntries')"
  width="100"
  *permissionIf="'Permissions.TimeEntries.StartStopTimeEntry'"
>
  <ng-template 
    kendoGridCellTemplate 
    let-dataItem
    let-isNew="isNew"
    >
      <input
        kendoTextBox
        [readonly]="true"
        [value]="dataItem.totalTimeEntries | timeSpanToString"
      />
  </ng-template>

  <ng-template 
    kendoGridFooterTemplate 
    let-column
    let-dataItem
  >
  <span>
    {{ (assignment$ | async)?.timeEntriesTotal | timeSpanToString }}
  </span>
</ng-template>
</kendo-grid-column>

  <kendo-grid-column
    [title]="t('timeEntries')"
    width="100"
    *permissionIf="'Permissions.TimeEntries.StartStopTimeEntry'"
  >
    <ng-template
      kendoGridCellTemplate
      let-dataItem="dataItem"
      let-isNew="isNew"
    >
    <button
      *ngIf="!isNew"
      kendoButton
      fillMode="solid"
      size="large"
      rounded="large"
      [themeColor]="assignmentServiceTimeEntryId == dataItem.id ? 'error': 'success'"
      (click)="onServiceTimeTracking(dataItem)"
    >{{assignmentServiceTimeEntryId == dataItem.id ? t('stop') : t('start')}}</button>
  </ng-template>

  <ng-template
    kendoGridEditTemplate
  >
    
  </ng-template>

  </kendo-grid-column>

  
  <kendo-grid-command-column
    [title]="t('action')"
    width="220"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary" *permissionIf="'Permissions.AssignmentServices.Update'">{{t('edit')}}</button>
      <button kendoGridRemoveCommand *permissionIf="'Permissions.AssignmentServices.Delete'">{{t('delete')}}</button>
      <button kendoGridSaveCommand themeColor="primary" [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>

  <!-- <ng-template
    let-totalPages="totalPages"
    let-currentPage="currentPage"
    kendoPagerTemplate
  >
  <div class="flex justSpaceBetween" style="width: 100%; flex-direction: row;">
      <div class="flex flexDirRow">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <div>
        <label for="pageBtnGroup" class="mrs">{{t('resultsPerPage')}}</label>
        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
          <button
            (click)="onPageSizeChange(pageSizes.Small)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Small"
            [toggleable]="true"
          >
            {{ pageSizes.Small }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Medium)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Medium"
            [toggleable]="true"
          >
            {{ pageSizes.Medium }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Large)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Large"
            [toggleable]="true"
          >
            {{ pageSizes.Large }}
          </button>
        </kendo-buttongroup>

        <button
          kendoButton
          [title]="t('refresh')"
          (click)="onGridReload()"
          icon="reload"
        ></button>
      </div>
    </div>
  </ng-template> -->
  <ng-template kendoGridNoRecordsTemplate>
    <div class="text pl">{{t('noResults')}}</div>
  </ng-template>

</kendo-grid>
</ng-container>